import React from 'react';

const STATUS_PLANNED = 'planned';
const STATUS_IN_PROGRESS = 'in_progress';
const STATUS_COMPLETE = 'complete';

const COLUMNS = [
  { id: STATUS_PLANNED, label: 'Planejado', color: '#3b82f6' },
  { id: STATUS_IN_PROGRESS, label: 'Em andamento', color: '#8b5cf6' },
  { id: STATUS_COMPLETE, label: 'Concluído', color: '#22c55e' }
];

/**
 * Vista do Roadmap: colunas por status (Planejado, Em andamento, Concluído).
 */
const RoadmapView = ({
  boards,
  selectedBoardId,
  onSelectBoard,
  postsByStatus,
  onPostClick,
  onVoteClick,
  votingPostId,
  showSidebar = true,
}) => {
  return (
    <div className="hub-roadmap-view-wrap">
      {showSidebar && (
        <aside style={{ width: 200, flexShrink: 0, padding: 24, borderRight: '1px solid #e2e8f0', background: '#fff' }}>
          <div data-hub-label style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', letterSpacing: '0.05em', marginBottom: 12 }}>QUADROS</div>
          {boards.map((board) => (
            <button
              type="button"
              key={board.id}
              onClick={() => onSelectBoard(board.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                padding: '10px 12px',
                marginBottom: 4,
                fontSize: 14,
                color: selectedBoardId === board.id ? '#1e293b' : '#64748b',
                background: selectedBoardId === board.id ? '#f1f5f9' : 'transparent',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer'
              }}
            >
              {board.name}
              {board.postCount != null && <span style={{ color: '#94a3b8' }}>{board.postCount}</span>}
            </button>
          ))}
        </aside>
      )}
      <div className="hub-roadmap-view">
        <div className="hub-roadmap-columns">
          {COLUMNS.map((col) => {
            const posts = postsByStatus[col.id] || [];
            return (
              <div key={col.id} className="hub-roadmap-column">
                <div className="hub-roadmap-column-header">
                  <span className="hub-roadmap-column-dot" style={{ background: col.color }} />
                  <span className="hub-roadmap-column-title">{col.label}</span>
                </div>
                <div className="hub-roadmap-column-cards">
                  {posts.length === 0 && (
                    <div className="hub-roadmap-column-empty">
                      <i className="bi bi-gear" aria-hidden />
                      Ainda não há ideias por aqui.
                    </div>
                  )}
                  {posts.map((post) => (
                    <div
                      key={post.id}
                      role="button"
                      tabIndex={0}
                      onClick={() => onPostClick(post)}
                      onKeyDown={(e) => e.key === 'Enter' && onPostClick(post)}
                      className="hub-roadmap-card"
                    >
                      <div className="hub-roadmap-card-inner">
                        <div
                          role="button"
                          tabIndex={votingPostId === post.id ? -1 : 0}
                          onClick={(e) => { e.stopPropagation(); if (votingPostId !== post.id) onVoteClick && onVoteClick(post); }}
                          onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); if (votingPostId !== post.id) onVoteClick && onVoteClick(post); } }}
                          className={`hub-roadmap-card-vote board-clickup-icon-btn-anchor${post.votedByMe ? ' is-voted' : ''}${votingPostId === post.id ? ' is-busy' : ''}`}
                        >
                          {votingPostId === post.id ? (
                            <i className="bi bi-arrow-repeat hub-vote-spin" aria-hidden />
                          ) : (
                            <>
                              <button
                                type="button"
                                className="hub-vote-chevron-btn"
                                onClick={(e) => { e.stopPropagation(); onVoteClick && onVoteClick(post); }}
                              >
                                <i className="bi bi-chevron-up" />
                              </button>
                              <span className="hub-vote-count hub-vote-count--sm">{post.voteCount ?? 0}</span>
                            </>
                          )}
                          <span className="board-clickup-tooltip board-clickup-tooltip--bottom hub-feedback-tooltip--wrap" role="tooltip">
                            {post.votedByMe ? 'Cancelar meu voto neste feedback' : 'Votar neste feedback'}
                          </span>
                        </div>
                        <div className="hub-roadmap-card-content">
                          <div className="hub-roadmap-card-title">{post.title}</div>
                          <div className="hub-roadmap-card-category">{post.categoryName || 'Atualizações'}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RoadmapView;
export { STATUS_PLANNED, STATUS_IN_PROGRESS, STATUS_COMPLETE };
